import { Reveal, Eyebrow } from "./Reveal";
import { caseStudy } from "../../data/resume";

export const CaseStudy = () => {
  return (
    <section
      id="case-study"
      data-testid="case-study-section"
      className="border-t border-hair bg-surface"
    >
      <div className="mx-auto max-w-[1400px] px-6 sm:px-12 lg:px-20 py-24 lg:py-36">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-5">
            <Reveal>
              <Eyebrow>(Case Study)</Eyebrow>
              <h2 className="mt-6 font-serif font-normal text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-ink">
                {caseStudy.title}
              </h2>
              <p className="mt-6 font-serif italic text-xl sm:text-2xl leading-snug text-inksoft">
                {caseStudy.subtitle}
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <div className="flex flex-col">
              {caseStudy.chapters.map((c, i) => (
                <Reveal key={c.label} delay={0.05 * i}>
                  <div
                    data-testid={`case-study-chapter-${i}`}
                    className="border-t border-hair py-8"
                  >
                    <div className="flex items-baseline gap-3">
                      <span className="font-mono text-xs text-rust">
                        0{i + 1}
                      </span>
                      <h3 className="font-serif text-2xl text-ink">{c.label}</h3>
                    </div>
                    <p className="mt-4 font-sans text-sm sm:text-base leading-relaxed text-inksoft">
                      {c.body}
                    </p>
                  </div>
                </Reveal>
              ))}
              <div className="border-t border-hair" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
